/**
 * 상담 관리 데모 페이지 (Mock 데이터 전용)
 * API 호출 없이 Mock 데이터만 표시
 */

import React, { useState } from 'react';
import {
  ChatBubbleBottomCenterTextIcon,
  XMarkIcon,
  MagnifyingGlassIcon,
  PlusIcon,
} from '@heroicons/react/24/outline';
import DemoNavigation from '../components/DemoNavigation';

// Mock 데이터
const mockStudents = [
  { id: '1', name: '김민수', member_number: 'STU001' },
  { id: '2', name: '이영희', member_number: 'STU002' },
  { id: '3', name: '박지훈', member_number: 'STU003' },
  { id: '4', name: '정수진', member_number: 'STU004' },
  { id: '5', name: '최동욱', member_number: 'STU005' },
];

const mockRecords = [
  // 김민수 학생 상담 기록 (3개)
  {
    id: '1',
    student_id: '1',
    student_name: '김민수',
    counseling_date: '2025-10-25',
    counseling_type: '학습상담',
    counselor_name: '김선생님',
    content: '수학 성적 향상을 위한 학습 계획 수립. 매일 2시간씩 문제풀이 연습 권장.',
    student_mood: '긍정적',
    follow_up_needed: true,
    follow_up_date: '2025-11-01',
  },
  {
    id: '6',
    student_id: '1',
    student_name: '김민수',
    counseling_date: '2025-10-18',
    counseling_type: '진로상담',
    counselor_name: '박선생님',
    content: '공과대학 진학 상담. 수학, 물리 성적 유지 및 향상 필요. 공학 관련 동아리 활동 권장.',
    student_mood: '보통',
    follow_up_needed: false,
  },
  {
    id: '11',
    student_id: '1',
    student_name: '김민수',
    counseling_date: '2025-10-10',
    counseling_type: '학습상담',
    counselor_name: '김선생님',
    content: '중간고사 결과 분석. 수학 90점, 영어 85점으로 전반적으로 우수. 영어 독해 부분 보완 필요.',
    student_mood: '긍정적',
    follow_up_needed: true,
    follow_up_date: '2025-10-25',
  },

  // 이영희 학생 상담 기록 (3개)
  {
    id: '2',
    student_id: '2',
    student_name: '이영희',
    counseling_date: '2025-10-24',
    counseling_type: '진로상담',
    counselor_name: '박선생님',
    content: '의대 진학 희망. 생물, 화학 과목 집중 학습 필요.',
    student_mood: '보통',
    follow_up_needed: false,
  },
  {
    id: '7',
    student_id: '2',
    student_name: '이영희',
    counseling_date: '2025-10-15',
    counseling_type: '학습상담',
    counselor_name: '이선생님',
    content: '생물 실험 보고서 작성 방법 지도. 과학 탐구 능력 향상을 위한 실험 프로젝트 참여 권장.',
    student_mood: '긍정적',
    follow_up_needed: true,
    follow_up_date: '2025-10-29',
  },
  {
    id: '12',
    student_id: '2',
    student_name: '이영희',
    counseling_date: '2025-10-05',
    counseling_type: '심리상담',
    counselor_name: '최선생님',
    content: '의대 진학 스트레스 관리. 과도한 학습 부담으로 인한 피로 누적. 휴식 시간 확보 필요.',
    student_mood: '피곤함',
    follow_up_needed: true,
    follow_up_date: '2025-10-24',
  },

  // 박지훈 학생 상담 기록 (2개)
  {
    id: '3',
    student_id: '3',
    student_name: '박지훈',
    counseling_date: '2025-10-23',
    counseling_type: '학습상담',
    counselor_name: '김선생님',
    content: '영어 듣기 실력 향상 필요. 매일 30분 영어 뉴스 청취 권장.',
    student_mood: '긍정적',
    follow_up_needed: true,
    follow_up_date: '2025-10-30',
  },
  {
    id: '8',
    student_id: '3',
    student_name: '박지훈',
    counseling_date: '2025-10-12',
    counseling_type: '진로상담',
    counselor_name: '박선생님',
    content: '경영학과 진학 상담. 수학 통계, 경제 과목 이수 권장. 경영 관련 독서 목록 제공.',
    student_mood: '긍정적',
    follow_up_needed: false,
  },

  // 정수진 학생 상담 기록 (3개)
  {
    id: '4',
    student_id: '4',
    student_name: '정수진',
    counseling_date: '2025-10-22',
    counseling_type: '심리상담',
    counselor_name: '이선생님',
    content: '시험 스트레스 관리. 규칙적인 운동과 충분한 수면 권장.',
    student_mood: '우울함',
    follow_up_needed: true,
    follow_up_date: '2025-10-29',
  },
  {
    id: '9',
    student_id: '4',
    student_name: '정수진',
    counseling_date: '2025-10-14',
    counseling_type: '학습상담',
    counselor_name: '김선생님',
    content: '국어 문학 작품 분석 능력 향상. 주요 작품 해설서 읽기 및 토론 학습법 소개.',
    student_mood: '보통',
    follow_up_needed: false,
  },
  {
    id: '13',
    student_id: '4',
    student_name: '정수진',
    counseling_date: '2025-10-08',
    counseling_type: '심리상담',
    counselor_name: '최선생님',
    content: '학업 동기 부여 상담. 작은 목표 설정을 통한 성취감 경험. 긍정적 자기 대화 연습.',
    student_mood: '보통',
    follow_up_needed: true,
    follow_up_date: '2025-10-22',
  },

  // 최동욱 학생 상담 기록 (2개)
  {
    id: '5',
    student_id: '5',
    student_name: '최동욱',
    counseling_date: '2025-10-21',
    counseling_type: '학습상담',
    counselor_name: '박선생님',
    content: '국어 독해력 향상을 위한 독서 계획. 주 2권 읽기 목표 설정.',
    student_mood: '긍정적',
    follow_up_needed: false,
  },
  {
    id: '10',
    student_id: '5',
    student_name: '최동욱',
    counseling_date: '2025-10-16',
    counseling_type: '진로상담',
    counselor_name: '이선생님',
    content: '법학 전공 희망. 논리적 사고력 향상을 위한 토론 수업 참여 권장. 시사 이슈 관심 필요.',
    student_mood: '긍정적',
    follow_up_needed: true,
    follow_up_date: '2025-11-02',
  },
];

const DemoConsultationPage: React.FC = () => {
  const [selectedRecord, setSelectedRecord] = useState<typeof mockRecords[0] | null>(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState<typeof mockStudents[0] | null>(null);
  const [studentSearch, setStudentSearch] = useState('');

  const filteredRecords = selectedStudent
    ? mockRecords.filter((r) => r.student_id === selectedStudent.id)
    : mockRecords;

  const filteredStudents = mockStudents.filter((s) =>
    s.name.toLowerCase().includes(studentSearch.toLowerCase()) ||
    s.member_number.toLowerCase().includes(studentSearch.toLowerCase())
  );

  const handleRecordClick = (record: typeof mockRecords[0]) => {
    setSelectedRecord(record);
    setShowDetailModal(true);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 데모 헤더 */}
      <div className="bg-blue-600 text-white py-3 px-4 text-center">
        <p className="text-sm">
          📢 이것은 데모 페이지입니다. 모든 데이터는 가상 데이터이며, 데모 시연을 위해 주기적으로 업데이트되어 조금씩 변동될 수 있습니다.
        </p>
      </div>

      {/* 네비게이션 */}
      <DemoNavigation currentTitle="상담 관리 (데모)" currentIcon={ChatBubbleBottomCenterTextIcon} />

      {/* 메인 컨텐츠 */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* 왼쪽: 학생 목록 */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow p-4">
              <h3 className="text-lg font-semibold mb-4 flex items-center">
                <MagnifyingGlassIcon className="h-5 w-5 mr-2" />
                학생 검색
              </h3>

              <input
                type="text"
                placeholder="이름 또는 회원번호 검색"
                value={studentSearch}
                onChange={(e) => setStudentSearch(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
              />

              <div className="space-y-2 max-h-96 overflow-y-auto">
                <button
                  onClick={() => setSelectedStudent(null)}
                  className={`w-full text-left px-3 py-2 rounded-lg transition-colors ${
                    !selectedStudent
                      ? 'bg-blue-50 text-blue-700 font-medium'
                      : 'hover:bg-gray-50'
                  }`}
                >
                  전체 학생
                </button>
                {filteredStudents.map((student) => (
                  <button
                    key={student.id}
                    onClick={() => setSelectedStudent(student)}
                    className={`w-full text-left px-3 py-2 rounded-lg transition-colors ${
                      selectedStudent?.id === student.id
                        ? 'bg-blue-50 text-blue-700 font-medium'
                        : 'hover:bg-gray-50'
                    }`}
                  >
                    <div className="font-medium">{student.name}</div>
                    <div className="text-sm text-gray-500">{student.member_number}</div>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* 오른쪽: 상담 기록 목록 */}
          <div className="lg:col-span-3">
            <div className="bg-white rounded-lg shadow">
              <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
                <h2 className="text-xl font-semibold">
                  {selectedStudent ? `${selectedStudent.name}님의 상담 기록` : '전체 상담 기록'}
                </h2>
                <button
                  disabled
                  className="flex items-center px-4 py-2 bg-gray-300 text-gray-500 rounded-lg cursor-not-allowed"
                  title="데모 모드에서는 추가할 수 없습니다"
                >
                  <PlusIcon className="h-5 w-5 mr-2" />
                  새 상담 기록
                </button>
              </div>

              <div className="p-6">
                {filteredRecords.length === 0 ? (
                  <div className="text-center py-12 text-gray-500">
                    상담 기록이 없습니다.
                  </div>
                ) : (
                  <div className="space-y-4">
                    {filteredRecords.map((record) => (
                      <div
                        key={record.id}
                        onClick={() => handleRecordClick(record)}
                        className="border border-gray-200 rounded-lg p-4 hover:border-blue-500 hover:shadow-md transition-all cursor-pointer"
                      >
                        <div className="flex items-start justify-between mb-2">
                          <div>
                            <h3 className="font-semibold text-lg">{record.student_name}</h3>
                            <p className="text-sm text-gray-500">{record.counseling_date}</p>
                          </div>
                          <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm">
                            {record.counseling_type}
                          </span>
                        </div>

                        <p className="text-gray-700 mb-2 line-clamp-2">{record.content}</p>

                        <div className="flex items-center justify-between text-sm">
                          <span className="text-gray-500">상담사: {record.counselor_name}</span>
                          {record.follow_up_needed && (
                            <span className="text-orange-600 font-medium">
                              후속상담 필요 ({record.follow_up_date})
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 상세 모달 */}
      {showDetailModal && selectedRecord && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white px-6 py-4 border-b border-gray-200 flex items-center justify-between">
              <h3 className="text-xl font-semibold">상담 기록 상세</h3>
              <button
                onClick={() => setShowDetailModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>

            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">학생</label>
                <p className="text-lg font-semibold">{selectedRecord.student_name}</p>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">상담일</label>
                  <p>{selectedRecord.counseling_date}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">상담 유형</label>
                  <p>{selectedRecord.counseling_type}</p>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">상담사</label>
                <p>{selectedRecord.counselor_name}</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">학생 분위기</label>
                <p>{selectedRecord.student_mood}</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">상담 내용</label>
                <p className="whitespace-pre-wrap bg-gray-50 p-4 rounded-lg">{selectedRecord.content}</p>
              </div>

              {selectedRecord.follow_up_needed && (
                <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
                  <p className="font-medium text-orange-800 mb-1">후속 상담 필요</p>
                  <p className="text-sm text-orange-600">예정일: {selectedRecord.follow_up_date}</p>
                </div>
              )}

              <div className="text-center pt-4 text-gray-500 text-sm">
                📢 데모 모드에서는 수정 및 삭제가 불가능합니다.
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DemoConsultationPage;
